import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';
import enviar from './../img/svg/Enviar(blanco).svg';
import { Solicitud_materia } from './expand/Solicitud_materia';
import { Resumen_Observaciones } from './tablas/Resumen_Observaciones';
import Swal from 'sweetalert2'

const API_URL = process.env.REACT_APP_API_URL;
function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
} 
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}
 
function PaoFormatter(cell, row) {
    switch (row.termino) {
        case "1ER TERMINO":
            return (
                <span>PAO-1</span>
            );
            break;
        case "2DO TERMINO":
            return (
                <span>PAO-2</span>
            );
            break;
        case "3ER TERMINO":
            return (
                <span>PAE</span>
            );
            break;
        default:
            return (
                <span>{cell}</span>
            );
            break;
    }
}


export class Admision extends Component {
    static displayName = Admision.name;

    handleBtnClick_mat = () => {
        if (!this.state.expanded_mat.includes(0)) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, 0]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand_mat = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], solicitudes: [],busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            }, materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            }, loading: false, loading2: false, total: 0, selectact: "", selectidact: "", abierto: false,
            materia_elegida: [
                { idcurso: 0, validada: "", estado_actividad: "" }
            ],
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ],
            anio: props.anio, terminoPeriodo: props.terminoPeriodo, idpersona: props.idprof, actividades_combo: [], periodo: "", newactividad: "", observacion: "", expanded_mat: [],
            fila_mat: [], selectact: "", selectidact: "", abierto: false, valida_next: false, valida_next: false, solicitudes_act: []
        };



        this.onChangePao = this.onChangePao.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.isValidated_all = this.isValidated_all.bind(this);
         
        this.closeExpandxId_mat = this.closeExpandxId_mat.bind(this);
        this.updatestate_mat = this.updatestate_mat.bind(this);

        this.setconteo_final = this.setconteo_final.bind(this);
    }

    setconteo_final(tam) {
        //console.log('setconteo final en docencia de grado')
        //console.log(tam)
        this.props.setconteo_final(tam, 'A')
    }

    componentDidMount() {
        let solicitudes = this.props.getSolicitudes('')
        if (solicitudes) {
            this.setState({
                solicitudes_act: solicitudes
            })
        }
        if (this.state.anio > 0) {  
            this.populateMateriasData(this.props.idprof, this.props.anio);
            this.populateActividadesCombo(this.props.idprof, this.props.anio);
        }
    }

    closeExpandxId_mat(idcurso) {
        //console.log('DENTRO DE EXPALNDID')

        //console.log(idcurso)
        //console.log(this.state.expanded_mat)
        if (this.state.expanded_mat.includes(idcurso)) {
            this.setState(() => ({
                expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
            }));
        }
    }
    updatestate_mat(rowIndex,idcurso, descripcion, observacion, anio, termino, totalhoras, accion, idUnico) {
        var solicitudes = this.state.solicitudes

        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idcurso)
        }

        solicitudes.push({
            idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, totalhoras: totalhoras, termino: termino, accion: accion
        })
        this.setState({
            solicitudes: solicitudes
        });
        //console.log('Admision: ')
        //console.log(JSON.stringify(solicitudes))
        //this.isValidated_all(this.states.fila_mat.length)
        this.props.update({ ambito: 'M|A', idactividad: idcurso, descripcion: descripcion, observacion: observacion, anio: anio, pao1: termino, pao2: termino, pae: termino, tipoactividad: 'AD', totalhoras: totalhoras, termino: termino, accion: accion, idUnico: idUnico})
        //console.log(JSON.stringify(this.state.solicitudes))
    }

    handleChange(e) {
        var idactividad = e.target.value;
        var data = this.state.actividades_combo.filter(x => x.idactividad == idactividad).map(act => act.descripcion);

        this.setState({ selectact: data, selectidact: e.target.value });
    }

    handleSearch(event) {
        this.setState({ observacion: event.target.value });
        //console.log(this.state.observacion);
    }


    /////FUNCIONES para interactuar con los si/no de Materias
    handleHideClick_mat = (idactividad) => {
        const check = document.getElementsByName("all_admi");
        check[0].checked = false;
        check[1].checked = false;

        let obj = this.state.fila_mat.find((o, i) => {
            if (o.idactividad === idactividad) {
                if (this.state.fila_mat[i].validacion === 'no') {
                    this.state.fila_mat[i].validacion = 'si'
                    return this.state.fila_mat[i];
                }
            }
        });
        if (obj == null) {
            this.state.fila_mat.push({
                idactividad: idactividad,
                validacion: 'si'
            })
        } else {
            this.mensaje_afirma(idactividad)
        }
        this.props.setconteo_final(this.state.fila_mat);
    }

    handleShowClick_mat = (idactividad) => {
        //console.log('MATERIA:' + idactividad)
        if (!this.state.expanded_mat.includes(idactividad)) {

            let obj = this.state.fila_mat.find((o, i) => {
                if (o.idactividad === idactividad) {
                    this.state.fila_mat[i].validacion = 'no'
                    return this.state.fila_mat[i];
                }
            });
            if (obj == null) {
                this.state.fila_mat.push({
                    idactividad: idactividad,
                    validacion: 'no'
                })
            }
            this.setState(() => ({
                expanded_mat: [...this.state.expanded_mat, idactividad]
            }));
        }
        //console.log(this.state.fila_mat);

        this.props.setconteo_final(this.state.fila_mat);
        if (!this.state.valida_next) {
            this.isValidated_all(this.state.fila_mat.length);
        }
    }

    handleHideAllClick_mat = () => {

        let filas = [];

        this.state.materias.forEach((element) => {
            filas.push({
                idactividad: element.idCurso,
                validacion: 'si'
            });
        })
        this.setState(() => ({
            expanded_mat: [],
            fila_mat: filas
        }));
        //console.log(this.state.expanded_mat);
        this.props.setconteo_final(filas);
        this.handleAllCheck_mat()
    }

    handleShowAllClick_mat = () => {

        let filas = [];
        let expandir = [];

        if (this.props.terminoPeriodo === "2S") {
            this.state.materias.forEach((element) => {
                if (element.termino === "3") {
                    filas.push({
                        idactividad: element.idCurso,
                        validacion: 'no'
                    });
                    if (!this.state.expanded_mat.includes(element.idCurso)) {
                        expandir.push(element.idCurso);
                    }
                } else {
                    filas.push({
                        idactividad: element.idCurso,
                        validacion: 'si'
                    });
                }
            });

        } else {
            this.state.materias.forEach((element) => {
                filas.push({
                    idactividad: element.idCurso,
                    validacion: 'no'
                });
                if (!this.state.expanded_mat.includes(element.idCurso)) {
                    expandir.push(element.idCurso);
                }
            });
        }

        this.setState(() => ({
            expanded_mat: this.state.expanded_mat.concat(expandir),
            fila_mat: filas
        }));
        //console.log('MATERIA:' + this.state.fila_mat);
        //console.log('MATERIA:' + this.state.materias);
        this.props.setconteo_final(filas);
        this.handleAllCheck_mat();
    }

    handleAllCheck_mat() {
        //console.log('MATERIA:' + this.state.fila_mat);
        const check = document.getElementsByName("all_admi");
        const checkSin = document.getElementById("Materias_admi").getElementsByClassName('form-check-input');
        //console.log('MATERIA:' + check);
        //console.log('MATERIA:' + checkSin);
        if (check[0].checked) {
            //console.log('MATERIA:' + 'Siu');
            for (let i = 0; i < checkSin.length; i++) {
                if (checkSin[i].value === "1") {
                    checkSin[i].checked = true;
                } else {
                    checkSin[i].checked = false;
                }
            }
            let chec = checkSin.length - 1
            //console.log('MATERIA:' + chec);
            if (!this.state.valida_next) {
                this.isValidated_all(chec);
            }
        } else {
            //console.log('NO A TODO CKICKK EN MATERIAS');
            for (let i = 0; i < checkSin.length; i++) {
                if (this.props.terminoPeriodo === "2S") {
                    if (checkSin[i].value === "0" && !checkSin[i].disabled) {
                        checkSin[i].checked = true;
                    }
                    //else {
                    //    checkSin[i].checked = false;
                    //}
                } else {
                    if (checkSin[i].value === "0") {
                        checkSin[i].checked = true;
                    } else {
                        checkSin[i].checked = false;
                    }
                }
            }
            let chec = checkSin.length - 1
            if (!this.state.valida_next) {
                this.isValidated_all(chec);
            }
        }
    }
    
    isValidated_all(tam) {
        let btncheckprevius = document.getElementsByClassName('btn-previous btn btn-secondary')[0];
        //if (btncheckprevius != undefined) {
        //    btncheckprevius.hidden = true;
        //}
        let btnchecknext = document.getElementsByClassName('btn-next btn btn-secondary')[0];

       // btnchecknext.disabled = true;
        //console.log('MATERIAS--->ES IGUAL: ' + tam + ' === ' + this.state.materias.length)
        if (tam >= this.state.materias.length) {
            //console.log('--->desbloquea siguiente ambito')
           // btnchecknext.disabled = false;
            this.setState({
                valida_next: true
            })
            //console.log('verifica vliidanext:' + this.state.valida_next)
           // btnchecknext.addEventListener('click', (e) => btnchecknext.disabled = true);

        }
    }

    onChangePao(event) {
        this.setState({
            periodo: event.target.value
        })
        //console.log(this.state.periodo)
    }

    mensaje_afirma(idcurso) {

        Swal.fire({
            title: '¿Está seguro de cambiar?',
            text: "Usted podría perder la selección y los datos ingresados de esta observación", 
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cambiar selección.',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (this.state.expanded_mat.includes(idcurso)) {
                    this.setState(() => ({
                        expanded_mat: this.state.expanded_mat.filter(x => x !== idcurso)
                    }));
                }

                this.props.setSolicitudes(0, idcurso)
                //Swal.fire({
                //    icon: 'success',
                //    text: 'Tu solicitud de Asignatura/Actividad ha sido eliminada',
                //    title: 'Eliminado',
                //    showConfirmButton: false,
                //    timer: 1500
                //})
            } else {

                let obj = this.state.fila_mat.find((o, i) => {
                    if (o.idactividad === idcurso) {
                        this.state.fila_mat[i].validacion = 'no'
                        return this.state.fila_mat[i];
                    }
                });
                const checksi = document.getElementById("ch1_" + idcurso);
                const checkno = document.getElementById("ch2_" + idcurso);
                //console.log('NO de mensaje afirma')
                checksi.checked = false;
                checkno.checked = true;
            }
        })
    }
    renderMateriasTable(materias) {

        const columns_materias = [
            {
                dataField: 'id',
                text: '#',

                headerStyle: color_head_desc('id'),
                style: (cell, row, rowIndex, colIndex) => {
                    return color(rowIndex)
                },
                formatter: (cellContent, row, rowIndex) => {
                    return (
                        <div>
                            {rowIndex + 1}
                        </div>
                    )
                }
            },{
            dataField: 'idCurso',
                text: 'Codigo',
            hidden:true,
            headerStyle: color_head_desc('id'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        }, {
            dataField: 'nombreMateria',
            text: 'Asignatura',
            headerStyle: color_head_desc('a'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'paralelo',
            text: 'Paralelo',
            headerStyle: color_head_desc('m'),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footer: ''
        },
        {
            dataField: 'termino',
            text: 'Periodo',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            formatter: PaoFormatter,
            footer: 'Subtotal: '
        },
        {
                dataField: 'anio',
                text: 'Anio',
                hidden:true,
        },
        {
            dataField: 'horasTotales',
            text: 'Horas',
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            },
            footerAlign: 'left',
            footer: columnData2 => {
                const total1 = columnData2.reduce((acc2, item2) => (Number(acc2) + Number(item2)).toFixed(2), 0);
                return (<>{total1.toLocaleString('en', { maximumFractionDigits: 2 })} horas</>);
            },
        },
        {
            dataField: 'conformidad',
            text: 'Validada',
            isDummyField: true,
            headerFormatter: (column, colIndex) => {
                return (
                    <div className="text-validada-center">
                        Validar<br />Seleccionar todo<label className="asterisco">*</label>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" name="all_admi" value="1" type="radio" onChange={this.handleHideAllClick_mat} />Si&nbsp;
                            <input className="form-check-input" name="all_admi" value="0" type="radio" onChange={this.handleShowAllClick_mat} />No

                         </div>
                    </div>

                )
            },
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" id={"ch1_" + row.idCurso} name={'ADM' + rowIndex} value="1" type="radio" onChange={() => this.handleHideClick_mat(row.idCurso)}
                                disabled={this.state.terminoPeriodo === "2S" && row.termino !== "3"}
                            />Si&nbsp;
                            <input className="form-check-input" id={"ch2_" + row.idCurso} name={'ADM' + rowIndex} value="0" type="radio" onChange={() => this.handleShowClick_mat(row.idCurso)}
                                disabled={this.state.terminoPeriodo === "2S" && row.termino !== "3"}
                            />No
                         </div>
                    </div>
                     // BLOQUEAR PAE en PAO1: (this.state.terminoPeriodo === "1S" && row.termino === "1") || (this.state.terminoPeriodo === "2S" && row.termino !== "3")
                );
            },
            headerStyle: color_head(),
            style: (cell, row, rowIndex, colIndex) => {
                return color(rowIndex)
            }
        }];

        const expandRow2 = {
            onlyOneExpanding: true,
            expanded: this.state.expanded_mat,
            expandByColumnOnly: true,
            renderer: (row, rowIndex) => (
                <div>
                    <Solicitud_materia rowIndex={rowIndex} idcurso={row.idCurso} descripcion={row.nombreMateria} paralelo={row.paralelo} observacion={row.observacion} anio={row.anio} termino={row.termino} totalhoras={row.horasTotales} idUnico={row.idUnico} updatestate={this.updatestate_mat} handleHideClick={this.handleHideClick_mat} closeExpandxId={this.closeExpandxId_mat} />
                </div>
            )
        };

        return (
            <BootstrapTable
                id='Materias_admi'
                keyField='idCurso'
                data={materias}
                columns={columns_materias}
                bordered={false}
                expandRow={expandRow2}
            />
        );

    }

    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }

    renderTotal() {
        const totalpepa = this.props.cargaMat ? this.props.cargaMat.map(horastot2 => horastot2.horasTotales).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambito = this.formatter(totalpepa);

        return (
            <div className="inline-grid  grid-cols-1 bg-total3">
                <div className="px-1 ">Total de Ámbito de Docencia de Admisión: {talambito} horas</div>
            </div>
        )
    }
    render() { 

        let contents_mat = this.renderMateriasTable(this.state.materias);
        let total = this.renderTotal()

        let btncheckprevius = document.getElementsByClassName('btn-previous btn btn-secondary')[0];
        //if (btncheckprevius != undefined) {
        //    btncheckprevius.hidden = true;
        //}

        if (this.state.valida_next) {
            let btnchecknext = document.getElementsByClassName('btn-next btn btn-secondary')[0];
            //if (btnchecknext != undefined) {
            //    btnchecknext.disabled = false;
            //    btnchecknext.addEventListener('click', (e) => btnchecknext.disabled = true);
            //}
        }


        return (
            <div>
                <Resumen_Observaciones solicitudes={this.state.solicitudes_act} anio={this.props.anio} tipoactividad='A' /> {/*updatestate={this.updatestate} />*/}
                {contents_mat}
                {total}
            </div>
        );
    }
          
    //OJO AQUi se usa la cedula 
    async populateMateriasData(idpersona, anio) {

        const respuesta = this.props.cargaMat;
        const data = respuesta;
        this.setState({ materias: data, loading2: false });
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idcurso: act.idCurso, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'MR', idactividad: act.idcurso, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino}) })
            data.map(act => { actividades.push({ ambito: 'M|A', idactividad: act.idCurso }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'M|A', idactividad: act.idCurso, anio: act.anio, descripcion: act.nombreMateria, periodo: act.termino, accion: '', observacion: '', totalhoras: act.horasTotales, validado: 1 }) })
            this.props.updateCarga(actividades, actividades2, 'M|A');
        }

        
        this.setState({ materia_elegida: selected, materias: data, loading: false }, () => {
            // AGREGAR MATERIAS VALIDADAS EN 1S
            //console.log("materias admisiones: ", this.state.materias);

            if (this.props.terminoPeriodo === "2S") {

                var checkSin = document.getElementById("Materias_admi").getElementsByClassName('form-check-input');

                this.state.materias.map((item, index) => {
                    if (item.termino.trim() === "1" || item.termino.trim() === "2") {
                        //console.log("termino != 2S: ", item);

                        var checkNeeded = checkSin["ch1_" + item.idCurso];
                        checkNeeded.checked = true;

                        this.state.fila_mat.push({
                            idactividad: item.idCurso,
                            validacion: 'si'
                        });
                    }
                });
                this.props.setconteo_final(this.state.fila_mat);
            }
        });

    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL+'TblActividades/' + anio + '/R/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }
}
